import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker.css";

import * as Yup from "yup";

import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  getCustomerList,
  getDealerList,
  getServiceEngineerList,
  getWorkOrderNoList,
} from "../master/AllUserDropDown";
// import {
//   getDealerDetailsById,
// } from "../../Service/AllAccessGetById";
import { getCustomerEntryById } from "../../Service/AllCustomerEntryAPI";
import { getDealerEntryById } from "../../Service/AllDealerEntryAPI";

import {
  getDispatchOrderNo,
  getWorkOrderNoWiseDispenser,
  postDispatch,
} from "../../Service/AllDispatchAPI";

import { ConnectedFocusError } from "focus-formik-error";
import DatePicker from "react-datepicker";
import DispatchGrid from "./DispatchGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Select from "react-select";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import fileSaver from "file-saver";
import moment from "moment";
import swal from "sweetalert";

const phoneRegEx = "^([0|+[0-9]{1,5})?([7-9][0-9]{9})$"; //validate Phone No

/* declaration of validationSchema
validation (based on the object schema provided by Yup) and display of validation errors */
const validationSchema = Yup.object().shape({
  workOrderNo: Yup.string().required("Select Work Order No *"),
    pincode: Yup.string()
      .required("Required *")
      .matches(/^[0-9]{6}$/, "Pincode must be 6 digits"),
  gatePassNumber: Yup.string()
    .required("Required *")
    .matches(/^[0-9]*$/, "Enter Numbers Only"),
  vehicleNo: Yup.string().required("Required *"),
  driverName: Yup.string()
    .required("Required *")
    .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
    .min(2, "Too Short !"),
  driverContactNo: Yup.string()
    .required("Required *")
    .matches(/^[0-9\s]+$/, "Enter Numbers only")
    .test("valid-phone", "Invalid Mobile number", (value) => {
      if (!value) return false;
      const cleanedNumber = value.replace(/\s/g, "");
      return /^\d{10}$/.test(cleanedNumber);
    })
    .matches(phoneRegEx, "Phone number is not valid")
    .matches(/^\d{10}$/, "Phone number must be 10 digits"),
  // dealerName: Yup.string().required("Required *"),
  // dispatchType: Yup.string().required("Required *"),
  // city: Yup.string().required("Required *")
  //   .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
  //   .min(2, "Too Short!"),
  address: Yup.string().required("Required *"),
  desc: Yup.string()
    .required("Required *")
    .min(4, "It should have minimum 4 characters!")
    .max(225, "It should have maximum 225 characters!"),
});

export default () => {
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [customerName, setCustomerName] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [userMblNo, setUserMblNo] = useState("");
  const [customerMblNo, setCustomerMblNo] = useState("");
  const [dealerName, setDealerName] = useState([]);
  const [dealerMblNo, setDealerMblNo] = useState("");
  const [selectedDealer, setSelectedDealer] = useState("");
  const [serviceEngineerName, setServiceEngineerName] = useState([]);
  const [selectedServiceEngineer, setSelectedServiceEngineer] = useState("");
  const [selectedDispenser, setSelectedDispenser] = useState([]);
  const [dispatchSrNo, setdispatchSrNo] = useState("");
  const [workOrderNo, setWorkOrderNo] = useState([]);
  const [selectedWorkOrderNo, setSelectedWorkOrderNo] = useState("");
  const [entries, serEntries] = useState([]);
  const [status, setStatus] = useState("ready to dispatch");
  const [disabled, setdisabled] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);
  const [time, setTime] = useState("");
  const [timeFormat, setTimeFormat] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState("");

    const [cityOptions, setCityOptions] = useState([]);
    const [loadingPin, setLoadingPin] = useState(false);
    const [pincode, setPincode] = useState("");
  

  const handleTimeChange = (event) => {
    // console.log("event.target.value :-", event.target.value);
    setSelectedTime(event.target.value);
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute] = time24.split(":");
    const parsedHour = parseInt(hour, 10);
    const period = parsedHour >= 12 ? "PM" : "AM";
    const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
    return `${formattedHour}:${minute} ${period}`;
  };

  const displayFormattedTime = selectedTime
    ? formatTimeTo12Hour(selectedTime)
    : "";

  useEffect(() => {
    getCustomersList(); // Function call to get customer list
    getDealersList();
    getServiceEngineersList();
    getWorkOrderList();
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        var form = event.target.form;
        var index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);

  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  // Function declaration of get dealers list
  const getDealersList = async () => {
    await getDealerList().then((result) => {
      setDealerName(result);
    });
  };

  // Function declaration of get Service Engineers list
  const getServiceEngineersList = async () => {
    await getServiceEngineerList().then((result) => {
      setServiceEngineerName(result);
    });
  };

  const getWorkOrderList = async () => {
    const status = ["ready to dispatch"];
    await getWorkOrderNoList(status).then((result) => {
      // console.log("WorkOrderNoList", result);
      setWorkOrderNo(result);
    });
  };


  const fetchAddressByPincode = async (pin, formik) => {
      if (pin.length !== 6) return;
  
      setLoadingPin(true);
  
      try {
        const res = await fetch(
          `https://api.postalpincode.in/pincode/${pin}`
        );
        const data = await res.json();
  
        if (data[0].Status === "Success") {
          const postOffices = data[0].PostOffice;
  
          setCountry("India");
          setState(postOffices[0].State);
  
          const cities = postOffices.map(po => ({
            label: po.Name,
            value: po.Name
          }));
  
          setCityOptions(cities);
  
          // optional auto select first city
          formik.setFieldValue("city", cities[0]?.value || "");
        } else {
  
          setState("");
          setCityOptions([]);
          formik.setFieldValue("city", "");
  
          swal("Invalid PIN", "No data found for this pincode", "warning");
        }
      } catch (err) {
        console.error(err);
        swal("Error", "Failed to fetch pincode data", "error");
      } finally {
        setLoadingPin(false);
      }
    };

  entries.map((item, index) => (item.id = index + 1));
  // Column heading of Product list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser sr No",
      editable: false,
    },
    { dataField: "workOrderNo", text: "Work Order No", editable: false },
    { dataField: "modelName", text: "Dispenser Type", editable: false },
  ];

  return (
    <Formik //Formik provides the Form, Field and ErrorMessage
      initialValues={{
        workOrderNo: "",
        gatePassNumber: "",
        vehicleNo: "",
        driverName: "",
        driverContactNo: "",
        customerFullName: "",
        // dealerName: "",
        dispatchDate: "",
        dispatchTime: "",
        // dispatchType: "",
        pincode:"",
        city: "",
        address: "",
        desc: "",
        modelName: "",
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm }) => {
        // declaration of onSubmit callback
        if (selectedWorkOrderNo === "") {
          swal("Failed", "Please Select Work Order No", "warning");
          return false;
        }
        if (selectedDispenser.length === 0) {
          swal("Failed", "Please Add Dispenser from grid", "warning");
          return false;
        }
        try {
          // code that we will 'try' to run
          const fkAdminId = sessionStorage.getItem("pkUserId");
          const fkAdminName = sessionStorage.getItem("userName");
          setisLoaded(true);
          setdisabled(true);
          const pkUserId = sessionStorage.getItem("pkUserId");
          const role = sessionStorage.getItem("role");
          let data = selectedDispenser.map((item) => {
            return {
              dispatchOrderNo: dispatchSrNo,
              workOrderNo: values.workOrderNo,
              gatePassNumber: values.gatePassNumber,
              vehicleNo: values.vehicleNo,
              driverName: values.driverName
                .toLowerCase()
                .split(" ")
                .map((word) => word.trim())
                .filter((word) => word !== "")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")
                .trimStart()
                .trimEnd(),
              driverContactNo: values.driverContactNo,
              fkAdminId: fkAdminId,
              adminName: fkAdminName,
              fkCustomerId: item.fkCustomerId,
              customerFullName: item.customerName,
              customerMobileNo: customerMblNo,
              fkDealerId: selectedDealer,
              // dealerName: values.dealerName,
              // mobileNo: dealerMblNo,
              // dispatchType: values.dispatchType,
              dispatchDate: moment(selectedDate, "DD/MMM/yyyy").format(
                // "DD/MMM/yyyy"
                "yyyy-MM-DD"
              ),
              dispatchTime: displayFormattedTime,
              country: country,
              state: state,
              city: values.city,
              address: values.address,
              status: status,
             pincode: values.pincode,
              description: values.desc,
              modelName: item.modelName,
              generateUniqueDispenserNo: item.generateUniqueDispenserNo,
              fkBackOfficeId: role === "back office" ? pkUserId : "",
            };
          });
          // console.log("Dispatch Data", data);
          // await postDispatch(data)
          //   .then((result) => {
          //     console.log("Dispatch Result", result);
          //     var blob = new Blob([result.data], { type: "application/pdf" });
          //     fileSaver.saveAs(blob, `DispatchReport.pdf`);
          //     setisLoaded(false);
          //     swal("Great", "Dispatch done successfully...", "success");
          //     resetForm();
          //     window.location.href = '/dispatch/dispatch-list';
          //   })
          await postDispatch(data)
            .then((result) => {
              // console.log("Dispatch Result", result);
              var blob = new Blob([result.data], { type: "application/pdf" });
              fileSaver.saveAs(blob, `DispatchReport.pdf`);
              setisLoaded(false);
              swal("Great", "Dispatch done successfully...", "success");

              // setTimeout(() => {
              //   resetForm();
              //   window.location.href = '/dispatch/dispatch-list'; 
              // }, 5000); 
            })

            .catch((error) => {
              setisLoaded(false);
              // console.log("Dispatch Error", error);
              if (error.response.status === 400) {
                console.log(
                  "error.response.data :-",
                  error.response.data.details
                );
                if (
                  error.response.data.details.includes(
                    "gate pass no should not empty"
                  )
                ) {
                  swal("Failed", "Please Enter Gate Pass No", "warning");
                  return false;
                }
                if (
                  error.response.data.details.includes(
                    "vehicle no should not empty"
                  )
                ) {
                  swal("Failed", "Please Enter Logistic Vehicle No", "warning");
                  return false;
                }
                if (
                  error.response.data.details.includes(
                    "driver name should not empty"
                  )
                ) {
                  swal("Failed", "Please Enter Driver Name", "warning");
                  return false;
                }
                if (
                  error.response.data.details.includes(
                    "driver contact no should not empty"
                  )
                ) {
                  swal("Failed", "Please Enter Driver Contact No", "warning");
                  return false;
                }
                if (
                  error.response.data.details.includes(
                    "address should not empty"
                  )
                ) {
                  swal("Failed", "Please Enter Address", "warning");
                  return false;
                }
                if (
                  error.response.data.details.includes(
                    "country should not empty"
                  )
                ) {
                  swal("Failed", "Please Enter Country", "warning");
                  return false;
                }
                if (
                  error.response.data.details.includes("state should not empty")
                ) {
                  swal("Failed", "Please Enter State", "warning");
                  return false;
                }
                if (
                  error.response.data.details.includes("city should not empty")
                ) {
                  swal("Failed", "Please Enter City", "warning");
                  return false;
                }
                if (
                  error.response.data.details.includes(
                    "discription should not empty"
                  )
                ) {
                  swal("Failed", "Please Enter Description", "warning");
                  return false;
                }
                if (
                  error.response.data.details.includes(
                    "dispatch order no should not empty"
                  )
                ) {
                  swal("Failed", "Please Enter Dispatch Order No", "warning");
                  return false;
                }
              }
            });
        } catch (error) {
          console.log(error);
          setisLoaded(false);
          swal(
            "Failed",
            "Please check entered data",
            "error"
          );
        }
      }}
    >
      {(formik) => {
        //Formik provides the Form, Field and ErrorMessage
        const { isValid, dirty, isSubmitting } = formik;
        const isdispatchbutton =selectedDate && displayFormattedTime && state && country ;
        return (
          <>
            {isLoaded ? (
              <div className="reportload"></div>
            ) : (
              <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                  <div className="d-flex">
                    <Link
                      to="dispatch-list"
                      className="fieldLink btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
                      Reports
                      <span className="icon icon-small ms-1"></span>
                    </Link>
                  </div>
                </div>
                <Card border="light" className="bg-white shadow-sm mb-4">
                  <Card.Body>
                    <h5 className="head mb-4">Create Dispatch Work Order</h5>
                    <h5 className="SrNo mb-4" align="right">
                      Dispatch Order No : {dispatchSrNo}
                    </h5>
                    {/* react-final-form */}
                    <Form>
                      <ConnectedFocusError />
                      <Row>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Production WO No *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Production Work Order No"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Production Work Order No"
                                  options={workOrderNo}
                                  onChange={async (e) => {
                                    formik.setFieldValue(
                                      "workOrderNo",
                                      e.value
                                    );
                                    setSelectedWorkOrderNo(e.value);
                                    await getWorkOrderNoWiseDispenser(e.value)
                                      .then((result) => {
                                        console.log(
                                          "Work Order No Wise Dispenser",
                                          result.data
                                        );
                                        console.log(
                                          "result?.data[0]?.fkCustomerId :-",
                                          result?.data[0]?.fkCustomerId
                                        );
                                        serEntries(result.data);
                                        const token =
                                          sessionStorage.getItem("token");
                                        const headers = {
                                          Authorization: `Bearer ${token}`,
                                        };
                                        getCustomerEntryById(
                                          headers,
                                          result?.data[0]?.fkCustomerId
                                        )
                                          .then((result) => {
                                            console.log(
                                              "getCustomerEntryById result :-",
                                              result.data
                                            );
                                            setCustomerMblNo(
                                              // result.data.customerMobileNo
                                              result.data.mobileNo
                                            );
                                          })
                                          .catch((error) => {
                                            console.log(
                                              "getCustomerEntryById error :-",
                                              error
                                            );
                                          });
                                        getDispatchOrderNo(
                                          result?.data[0]?.customerName
                                        )
                                          .then((result) => {
                                            console.log(
                                              "Dispatch Sr No",
                                              result.data
                                            );
                                            setdispatchSrNo(result.data);
                                          })
                                          .catch((error) => {
                                            console.log(
                                              "Dispatch Error",
                                              error
                                            );
                                          });
                                      })
                                      .catch((error) => {
                                        console.log("Dispatch Error", error);
                                      });
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="workOrderNo"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Gate Pass No. *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Gate Pass No"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="gatePassNumber"
                                  placeholder="Enter Gate Pass No."
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="gatePassNumber"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Logistic Vehicle No. *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Logistic Vehicle No"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="vehicleNo"
                                  placeholder="Enter Logistic Vehicle No."
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="vehicleNo"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Driver Name *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Driver Name"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="driverName"
                                  placeholder="Enter Driver Name"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="driverName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Driver Contact No. *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Driver Contact No"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="driverContactNo"
                                  placeholder="Enter Driver Contact No."
                                  maxLength="10"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="driverContactNo"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Customer Name</label>
                            <Field
                              placeholder="Customer Name"
                              name="customerFullName"
                              className="form-control"
                              // options={customerName}
                              value={entries[0]?.customerName}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Customer Mobile No{" "}
                            </label>
                            <Field
                              type="text"
                              name="customerMobileNo"
                              value={customerMblNo}
                              className="form-control"
                              placeholder="Enter Customer Mobile No"
                              readOnly
                            />
                          </div>
                        </Col>
                        {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Dealer Name *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Dealer Name"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Dealer Name"
                                  options={dealerName}
                                  onChange={async (e) => {
                                    formik.setFieldValue("dealerName", e.value);
                                    setSelectedDealer(e.id);
                                    const token =
                                      sessionStorage.getItem("token");
                                    const headers = {
                                      Authorization: `Bearer ${token}`,
                                    };
                                    await getDealerEntryById(
                                      headers,
                                      e.id
                                    ).then((result) => {
                                      console.log(
                                        "getDealerEntryById",
                                        result.data
                                      );
                                      setDealerMblNo(result.data.mobileNo);
                                    });
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="dealerName"
                              component={TextError}
                            />
                          </div>
                        </Col> */}
                        {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Dealer Mobile No
                            </label>
                            <Field
                              type="text"
                              name="mobileNo"
                              value={dealerMblNo}
                              className="form-control"
                              placeholder="Dealer Mobile No"
                              readOnly
                            />
                          </div>
                        </Col> */}
                        {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Dispatch Type *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Dispatch Type"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="dispatchType"
                                  placeholder="Enter Dispatch Type"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="dispatchType"
                              component={TextError}
                            />
                          </div>
                        </Col> */}
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Dispatch Date *
                            </label>
                            <br />
                            <div className="example-wrapper">
                              <ToolTip content="Select Date" direction="bottom">
                                <DatePicker
                                  showIcon
                                  // closeOnScroll={true}
                                  closeOnScroll={(e) => e.target === document}
                                  className="form-control"
                                  dateFormat="dd-MMM-yyyy"
                                  placeholderText="Select Date"
                                  selected={selectedDate}
                                  onChange={(date) => {
                                    setSelectedDate(date);
                                  }}
                                  // minDate={new Date()} // Set the minimum selectable date to today
                                />
                              </ToolTip>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Dispatch Time *
                            </label>
                            <br />
                            <div className="time-wrapper">
                              <div className="allTime">
                                <input
                                  type="time"
                                  // value={selectedTime}
                                  onChange={handleTimeChange}
                                  className="form-control"
                                />
                              </div>
                              <div className="addTime">
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Select Time from Widget"
                                    direction="bottom"
                                  >
                                    <Field
                                      className="form-control"
                                      name="dispatchTime"
                                      placeholder="Select Time from Widget"
                                      value={displayFormattedTime}
                                      readOnly
                                    />
                                  </ToolTip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Pincode *</label>
                            <Field
                              type="text"
                              className="form-control"
                              name="pincode"
                              autoComplete="off"
                              maxLength="6"
                              placeholder="Enter Pincode"
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) e.preventDefault();
                              }}
                              onChange={(e) => {
                                formik.handleChange(e);
                                setPincode(e.target.value);
                                fetchAddressByPincode(e.target.value, formik);
                              }}

                            />
                            <ErrorMessage name="pincode" component={TextError} />
                          </div>
                        </Col>


                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Country *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Country"
                                direction="bottom"
                              >

                                <input
                                  className="form-control"
                                  value={country}
                                  readOnly
                                />

                              </ToolTip>
                            </div>
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">State </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select State"
                                direction="bottom"
                              >

                                <input
                                  className="form-control"
                                  value={state}
                                  readOnly
                                />

                              </ToolTip>
                            </div>
                          </div>
                        </Col>


                      </Row>
                      <Row>



                        <Col md={6} className="mb-3">
                          <label className="LabelNew mb-1">City *</label>
                          <Select
                            placeholder={loadingPin ? "Loading..." : "Select City"}
                            options={cityOptions}
                            isDisabled={!cityOptions.length}
                            value={cityOptions.find(c => c.value === formik.values.city) || null}
                            onChange={(e) => formik.setFieldValue("city", e.value)}
                          />
                          <ErrorMessage name="city" component={TextError} />
                        </Col>


                       

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Warehouse Address *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Warehouse Address of Dispatch"
                                direction="bottom"
                              >
                                <Field
                                  className="form-control"
                                  name="address"
                                  placeholder="Enter Warehouse Address of Dispatch"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="address"
                              component={TextError}
                            />
                          </div>
                        </Col>
                   
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Description *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Suitable Description"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="3"
                                  maxLength={100}
                                  className="form-control"
                                  name="desc"
                                  placeholder="Enter Description"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage name="desc" component={TextError} />
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <DispatchGrid
                          columns={columns}
                          entries={entries}
                          sendFromDispatchGrid={setSelectedDispenser}
                        />
                      </Row>
                      <div className="mt-3">
                        <Button
                          variant="primary"
                          type="submit"
                          disabled={!(formik.isValid && formik.dirty && selectedDispenser.length > 0) || formik.isSubmitting || !isdispatchbutton}
                        >
                          Create Dispatch WO
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </>
            )}
          </>
        );
      }}
    </Formik>
  );
};
